import React,{Component} from "react";
import Auxiliary from "../Components/HOC/Auxiliary";
import Home from "../Pages/Home/Home";
import {Switch, Route} from "react-router-dom";
import SearchResults from "../Pages/SearchResults/SearchResults";
import SearchResultsImages from "../Pages/SearchResultsImages/SearchResultsImages";

class App extends Component{
    render(){
        return(
            <Auxiliary>
                <main>
                    
                    <Switch>
                        {/* Home (the interface page) */}
                        <Route exact path="/" component={Home} />
                        {/* search (the results page) */}
                        <Route exact path="/search-results/all" component={SearchResults}  />
                        <Route exact path="/search-results/images" component={SearchResultsImages}  />
                    </Switch>
                </main>
            </Auxiliary>
        )
    }
} 

export default App;